import { ApolloProvider } from 'core/net/ApolloProvider';
import { CREATE_OR_UPDATE_NOISE_EVENT_POLICY_OVERRIDE } from './graphql/facility.createOrUpdateNoiseEventPolicyOverride';
import {
  CreateOrUpdateNoiseEventPolicyOverride,
  CreateOrUpdateNoiseEventPolicyOverrideMutation,
  CreateOrUpdateNoiseEventPolicyOverrideMutationVariables,
} from 'app/__generated__/global';

export const createOrUpdateNoiseEventPolicyOverride = async (input: CreateOrUpdateNoiseEventPolicyOverride) => {
  const { data, error } = await ApolloProvider.global().mutate<
    CreateOrUpdateNoiseEventPolicyOverrideMutation,
    CreateOrUpdateNoiseEventPolicyOverrideMutationVariables
  >({
    mutation: CREATE_OR_UPDATE_NOISE_EVENT_POLICY_OVERRIDE,
    variables: {
      input,
    },
  });
  if (!data || error)
    throw new Error(
      `Something went wrong when trying to create or update noise event policy override: ${error?.message}`
    );
  const result = data.facility.noiseEventPolicyOverrides.createOrUpdateNoiseEventPolicyOverride;
  return result;
};
